@if (control) {
  <ng-select
    [loading]="loading$ | async"
    [formControl]="control"
    [items]="(profiles$ | async) ?? []"
    bindLabel="full_name"
    [placeholder]="'USERS.SEARCH' | translate"
    (search)="onSearch($event.term)"
    (change)="selectedOptionChanged.next($event)"
    (scrollToEnd)="onScrollToEnd()"
    (clear)="onClear()"
  >
    <ng-template ng-option-tmp let-item="item">
      <div class="ng-option-content-multiline">
        <span>{{ item.full_name }}</span>
        <span class="gb-truncate gb-profile-select-detail"> {{ item.email || item.phone_number }} </span>
        @if (item.paddle_number) {
          <span
            class="gb-profile-select-detail"
            translate="SHARED.PADDLE_NUMBER.ASSIGN_DIALOG.PADDLE_NUMBER"
            [translateParams]="{ paddleNumber: item.paddle_number }"
          >
          </span>
        }
      </div>
    </ng-template>
  </ng-select>

  @if (control.invalid && control.touched) {
    <span class="ng-select-error">
      {{ 'FORMS.ERROR.FIELD_REQUIRED' | translate }}
    </span>
  }
}
